module.exports = __webpack_public_path__ + "img/telegram.ed6d89ce.svg";